// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
// Helpers
import { isStoreOrganization } from 'helpers/user';
// Layouts
import Main from 'layouts/Main/Main';
// Components
import StreamsPlaylist from './components/StreamsPlaylist/StreamsPlaylist';
import PromoAma from './components/PromoAma/PromoAma';
// Styles
import styles from './FinishedStream.module.scss';

type FinishedStreamProps = {
  stream: GetStream_stream;
  refetchStream: () => void;
};

const FinishedStream = ({ stream, refetchStream }: FinishedStreamProps) => {
  return (
    <Main
      backgroundColor="white"
      className={styles.root}
      withoutBottomPadding
      withoutSidesPadding
    >
      <div className={styles.contentWrapper}>
        <StreamsPlaylist stream={stream} refetchStream={refetchStream} />
        {!!stream?.store?.hasAma && !isStoreOrganization(stream?.store) && (
          <PromoAma storeSlug={stream?.store?.slug || ''} />
        )}
      </div>
    </Main>
  );
};

export default FinishedStream;
